import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'product-tags',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  const instance = getCurrentInstance();
  const proxy = instance?.proxy as Vue;

  

  const isSearchProduct = computed(() => {
    return props.product && !props.product.hasOwnProperty('inventory_item');
  });

  const productOption = computed(() => {
    if (
      isSearchProduct.value
      && props.product
      && Object.hasOwnProperty.call(props.product, 'productOptions')
    ) {
      return props.product?.productOptions[0]?.meta?.product_option_code;
    } else if (props.product?.inventoryItem?.product_option?.code) {
      return props.product?.inventoryItem?.product_option?.code
    }

    return props.product?.inventory_item?.product_option?.code;
  });

  const isPrivateLounge = computed(() => {
    return productOption.value === 'lounge_private';
  });

  const privateLoungeFlyingDirection = computed(() => {
    let flyingDirection;
    if (props.product?.details?.direction) {
      flyingDirection = props.product.details.direction;
    } else if (isSearchProduct.value && props.product?.productOptions?.length) {
      flyingDirection = props.product?.productOptions[0]?.meta?.direction;
    }
    return (flyingDirection ?? 'inbound').toLowerCase();
  });

  const tags = computed(() => {
    let tags = [];
    if (isPrivateLounge.value) {
      tags.push(
        tagTranslation(
          'privateLounge',
          privateLoungeFlyingDirection.value
        )
      );
    }
    if (props.product.productHeader?.product_code === 'fasttrack' ||
      props.product.product_code === 'fasttrack') {
      tags.push(tagTranslation('fasttrack', productOption.value));
    }
    return tags;
  });

  function tagTranslation(section, key) {
    return proxy.$t(`UI.productSummaryCard.tags.${section}.${key}`);
  }

return { __sfc: true,instance, proxy, props, isSearchProduct, productOption, isPrivateLounge, privateLoungeFlyingDirection, tags, tagTranslation }
}

})